/* eslint-disable */
import React, { useEffect, useState } from 'react';

import * as S from './styles';
import { Add, Subtract } from 'styled-icons/fluentui-system-regular';

interface NumberInputProps {
  value?: number;
  onChange?: (value: number) => void;
  min?: number;
  max?: number;
}

const NumberInputComponent: React.FC<NumberInputProps> = ({
  value = 1,
  onChange,
  min = 1,
  max = 999,
}) => {
  const [inputValue, setInputValue] = useState<string>(value.toString());
  const [numericValue, setNumericValue] = useState(value);

  useEffect(() => {
    setInputValue(value.toString());
    setNumericValue(value);
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    // Permite string vazia ou apenas números
    if (newValue === '' || /^\d+$/.test(newValue)) {
      setInputValue(newValue);
      // Remove o onChange daqui - só atualiza o estado local
    }
  };

  const handleBlur = () => {
    let finalValue: number;

    if (inputValue === '' || inputValue === '0') {
      // Se estiver vazio ou zero, define o valor mínimo
      finalValue = min;
    } else {
      const parsed = parseInt(inputValue);
      if (parsed > max) {
        // Se for maior que o máximo, define o valor máximo
        finalValue = max;
      } else if (parsed < min) {
        // Se for menor que o mínimo, define o valor mínimo
        finalValue = min;
      } else {
        finalValue = parsed;
      }
    }

    setInputValue(finalValue.toString());
    setNumericValue(finalValue);

    // Só chama onChange aqui, no blur
    onChange?.(finalValue);
  };

  const handleIncrement = () => {
    const currentValue = inputValue === '' ? min : parseInt(inputValue);
    if (currentValue < max) {
      const newValue = currentValue + 1;
      setInputValue(newValue.toString());
      setNumericValue(newValue);
      onChange?.(newValue); // Mantém onChange nos botões
    }
  };

  const handleDecrement = () => {
    const currentValue = inputValue === '' ? min : parseInt(inputValue);
    if (currentValue > min) {
      const newValue = currentValue - 1;
      setInputValue(newValue.toString());
      setNumericValue(newValue);
      onChange?.(newValue); // Mantém onChange nos botões
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    // Permite apenas números e teclas de controle
    if (
      !/[0-9]/.test(e.key) &&
      ![
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'Tab',
        'Enter',
      ].includes(e.key)
    ) {
      e.preventDefault();
    }
  };

  const getCurrentNumericValue = () => {
    return inputValue === '' ? min : parseInt(inputValue);
  };

  return (
    <S.InputNumberWrapper>
      <S.NumberButton
        type="button"
        disabled={getCurrentNumericValue() <= min}
        onClick={handleDecrement}
      >
        <Subtract size={24} />
      </S.NumberButton>

      <S.NumberInput
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyPress}
        placeholder={min.toString()}
      />

      <S.NumberButton
        type="button"
        disabled={getCurrentNumericValue() >= max}
        onClick={handleIncrement}
      >
        <Add size={24} />
      </S.NumberButton>
    </S.InputNumberWrapper>
  );
};

export default NumberInputComponent;
